// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PassbookPage from './pages/PassbookPage';
import BillDetailPage from './pages/BillDetailPage'; // Import the new component
import { useState } from 'react';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Router>
      <Routes>
        {/* Login Page */}
        <Route
          path="/"
          element={<LoginPage onLogin={() => setIsAuthenticated(true)} />}
        />

        {/* Passbook Page (default after login) */}
        <Route
          path="/passbook"
          element={isAuthenticated ? <PassbookPage /> : <Navigate to="/" />}
        />

        {/* Bill Detail Page - NEW ROUTE */}
        <Route
          path="/bill/:username/:fromDate/:toDate"
          element={isAuthenticated ? <BillDetailPage /> : <Navigate to="/" />}
        />

        {/* Dashboard Page (optional, if you still need it) */}
        <Route
          path="/dashboard"
          element={isAuthenticated ? <DashboardPage /> : <Navigate to="/" />}
        />

        {/* Fallback route - redirect to login if no route matches */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;